import axios from "axios";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useOutletContext, useParams,useSearchParams  } from "react-router-dom";
import $, { error } from "jquery";
import toastr from "../../utils/toast";
import AddContact from "../../components/Modals/Orders/AddContact";
import useSmartBack from "../../hooks/useSmartBack";

function AddNewRole() {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
const isConvert = searchParams.get("mode") === "convert";

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    unregister,
  } = useForm();

  const navigate = useNavigate();
  const handleBack = useSmartBack(id ? `/role/view/${id}` : "/role/list");

  const { setGlobalLoading, token } = useOutletContext();
  const REACT_APP_API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const CURRENCY_API_KEY = process.env.REACT_APP_CURRENCY_API_KEY;
  const [data, setData] = useState([]);
  const [clientContact, setClientContact] = useState([]);
  const [region, setRegion] = useState(null);
  const [conversionRate, setConversionRate] = useState(1);
  const [duties, setDuties] = useState([]);
  const [extraInputs, setExtraInputs] = useState([0, 1, 2]);
  const [roleType, setRoleType] = useState(2);
  const [reportType, setReportType] = useState(1);
  const [RoleData, setRoleData] = useState([]);
  const [selectedClientId, setSelectedClientId] = useState(null);
  const [showAddContactModal, setShowAddContactModal] = useState(false);

  useEffect(() => {
    const getBasicDetails = async () => {
      try {
        setGlobalLoading(true);
        const response = await axios.get(
          `${REACT_APP_API_BASE_URL}/roles/basic_add_role_form_details`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        console.log(response.data);
        setData(response.data);
        setValue("reference", response.data.next_reference?.[0]?.next_reference);
        setValue("rolestatus_id", response.data.status[0].id);
        setValue("roletype_id", 2);
        setValue("currency_id_alt", response.data.currency[0].id);
        setValue("reporttype_id", response.data.reporttype[0].id);
      } catch (error) {
        console.log(error);
        setGlobalLoading(false);
      } finally {
        setGlobalLoading(false);
      }
    };
    getBasicDetails();
  }, []);

  useEffect(() => {
  if (!data?.companies?.length || !data?.user?.length) return;

  const timer = setTimeout(() => {
    const client = $("[name='company_id']");
    const role_manager = $("[name='user_id']");

    // destroy old
    if (client.hasClass("select2-hidden-accessible")) {
      client.select2("destroy");
    }

    if (role_manager.hasClass("select2-hidden-accessible")) {
      role_manager.select2("destroy");
    }

    client.select2({
      placeholder: "Select Active Client",
      width: "100%",
      allowClear: true,
    });

    role_manager.select2({
      placeholder: "Select Role Manager",
      width: "100%",
      allowClear: true,
    });

    const handleSelect = (e) => {
      const selectedValue = e.params.data.id;

      setValue("company_id", selectedValue);
      setSelectedClientId(selectedValue);
      getClientContact(selectedValue);
    };

    const handleSelectRoleManager = (e) => {
      const selectedValue = e.params.data.id;
      setValue("user_id", selectedValue);
    };

    const handleClear = () => {
      setClientContact([]);
      setSelectedClientId(null);
    };

    client.on("select2:select", handleSelect);
    client.on("select2:clear", handleClear);

    role_manager.on("select2:select", handleSelectRoleManager);

  }, 100);

  return () => {
    clearTimeout(timer);

    const client = $("[name='company_id']");
    const role_manager = $("[name='user_id']");

    client.off("select2:select");
    client.off("select2:clear");

    role_manager.off("select2:select");

    if (client.hasClass("select2-hidden-accessible")) {
      client.select2("destroy");
    }

    if (role_manager.hasClass("select2-hidden-accessible")) {
      role_manager.select2("destroy");
    }
  };
}, [data?.companies, data?.user]);

  const getClientContact = async (id) => {
    try {
      const response = await axios.get(
        `${REACT_APP_API_BASE_URL}/clients/getClientContacts/${id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setClientContact(response.data);
    } catch (error) {
      console.log(error);
      setGlobalLoading(false);
    } finally {
      setGlobalLoading(false);
    }
  };

  const getRegions = async (region_id) => {
    try {
      const response = await axios.get(
        `${REACT_APP_API_BASE_URL}/common_controller/get_regions_by_country_id/${region_id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setValue("region_id", response.data.regions[0].id);
      setRegion(response.data.regions[0].name);
    } catch (error) {
      console.log(error);
      setGlobalLoading(false);
    } finally {
      setGlobalLoading(false);
    }
  };
  const handleCountryChange = (e) => {
    const selectedCountryId = parseInt(e.target.value);

    if (selectedCountryId) {
      console.log(selectedCountryId);
      const region_id = data?.country?.find(
        (c) => c.id === selectedCountryId
      )?.region_id;

      getRegions(region_id);
    }
  };

  const getConversation = async (name) => {
    try {
      const response = await axios.get(
        `https://api.currconv.com/api/v7/convert?q=${name}_INR&compact=ultra&apiKey=${CURRENCY_API_KEY}`
      );
      const rate = response.data;
      const [currency, value] = Object.entries(rate)[0];
      setValue("conversion_rate", value || 1);
      setConversionRate(value ?? 1);
    } catch (error) {
      console.log(error);
      setGlobalLoading(false);
    } finally {
      setGlobalLoading(false);
    }
  };

  const handleCurrencyChange = (e) => {
    const selectedCurrencyId = parseInt(e.target.value);
    if (selectedCurrencyId) {
      const currency = data?.currency?.find(
        (c) => c.id === selectedCurrencyId
      )?.name;
      getConversation(currency);
    }
  };

  const get_minor_functions = async (id) => {
    try {
      const response = await axios.get(
        `${REACT_APP_API_BASE_URL}/common_controller/get_minor_functions/${id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setDuties(response.data.minor_functions);

      const minor_functions = $("[name='duty_id']");

      minor_functions.select2({
        placeholder: "Select Duty",
        width: "100%",
        closeOnSelect: false,
        allowClear: true,
        multiple: true,
      });

      minor_functions.off("select2:select select2:unselect"); // clear old bindings
      minor_functions.on("select2:select select2:unselect", function () {
        const selectedValues = $(this).val(); // <-- array of all selected IDs
        setValue("duty_id", selectedValues || []);
      });
    } catch (error) {
      console.log(error);
      setGlobalLoading(false);
    } finally {
      setGlobalLoading(false);
    }
  };

  const handleDutyMasterChange = (e) => {
    const selectedDutyMasterId = parseInt(e.target.value);
    if (selectedDutyMasterId) {
      get_minor_functions(selectedDutyMasterId);
    } else {
      setDuties([]);
    }
  };

  const handleAddMore = (e) => {
    e.preventDefault();
    setExtraInputs((prev) => [...prev, prev.length]);
  };

  const handleRoleTypeChange = (e) => {
    const selectedRoleTypeId = parseInt(e.target.value);
    setRoleType(selectedRoleTypeId);
  };

  const reportTypeChange = (e) => {
    const selectedReportTypeId = parseInt(e.target.value);
    setReportType(selectedReportTypeId);
  };

  const fetch_role_data = async (id) => {
    try {
      setGlobalLoading(true);
      const response = await axios.get(
        `${REACT_APP_API_BASE_URL}/roles/fetch_role_data/${id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setRoleData(response.data);
      console.log(response.data);
    } catch (error) {
      console.log(error);
      setGlobalLoading(false);
    } finally {
      setGlobalLoading(false);
    }
  };

  useEffect(() => {
    if (!id) return;
    fetch_role_data(id);
  }, [id]);

  useEffect(() => {
    const role_data = RoleData?.role_data?.[0];
    const role_criterias = RoleData?.rolecriterias;

    if (!role_data && !role_criterias) return;

    setValue("name", role_data?.name);
    setValue("reference", role_data?.reference);
    data?.roletype?.find((r) => {
      if (r.id === role_data?.roletype_id) {
        setValue("roletype_id", r.id);
        setRoleType(r.id);
      }
    });

    data?.companies?.find((c) => {
      if (c.id === role_data?.company_id) {
        setValue("company_id", c.id);
        getClientContact(c.id);
      }
    });

    data?.reporttype?.find((r) => {
      if (r.id === role_data?.reporttype_id) {
        setValue("reporttype_id", r.id);
        setReportType(parseInt(r.id));
      }
    });
    setValue("otherreport", role_data?.otherreport || "");
    data?.user?.find((u) => {
      if (u.id === role_data?.user_id) {
        setValue("user_id", u.id);
      }
    });

    data?.billtype?.find((b) => {
      if (b.id === role_data?.billtype_id) {
        setValue("billtype_id", b.id);
      }
    });

    data?.rolelevel?.find((r) => {
      if (r.id === role_data?.rolelevel_id) {
        setValue("rolelevel_id", r.id);
      }
    });

    setValue("band", role_data?.band || "");

    data?.country?.find((c) => {
      if (c.id === role_data?.country_id) {
        setValue("country_id", c.id);
        handleCountryChange({ target: { value: c.id } });
      }
    });

    setValue("compensation_range_from", role_data?.compensation_range_from || "");
    setValue("compensation_range_to", role_data?.compensation_range_to || "");
    setValue("location", role_data?.location || "");
    setValue("expected_compensation", role_data?.expected_compensation || "");
    data?.currency?.find((c) => {
      if (c.id === role_data?.currency_id) {
        setValue("currency_id_alt", c.id);
        //handleCurrencyChange({ target: { value: c.id } });
      }
    });
    setValue("expected_approx_fee", role_data?.expected_approx_fee || "");
    data?.dutymaster?.find((d) => {
      if (d.id === role_data?.dutymaster_id) {
        setValue("dutymaster_id", d.id);
        handleDutyMasterChange({ target: { value: d.id } });
      }
    });

    setValue("active", role_data?.active === "1" ? true : false);
    setValue("dossier", role_data?.dossier === "1" ? true : false);
    setValue("position_number", role_data?.position_number || "");
    setValue("start", role_data?.start || "");
    setValue("description", role_data?.description || "");
    setValue("invoiceAddress", role_data?.invoiceAddress || "");
    setValue("note", role_data?.note || "");

    data?.status?.find((s) => {
      if (s.id === role_data?.rolestatus_id) {
        setValue("rolestatus_id", s.id);
      }
    });

    if (role_criterias?.length > 0) {
      setExtraInputs(role_criterias.map((_, i) => i));
      role_criterias?.forEach((c, i) => {
        setValue(`p_scnt.${i}`, c.name);
      });
    }
    setValue("conversion_rate", role_data?.conversion_rate || 1);
    setConversionRate(role_data?.conversion_rate ?? 1);
  }, [RoleData, data]);

  useEffect(() => {
    const role_data = RoleData?.role_data?.[0];
    const dutyIds = role_data?.duty_id?.split(",").map((id) => id.trim()) || [];
    setTimeout(() => {
      clientContact?.client_contacts?.find((c) => {
        if (c.id === parseInt(role_data?.client_id)) {
          setValue("client_id", c.id);
        }
      });
      const minor_functions = $("[name='duty_id']");
      minor_functions.find("option").remove();
      duties?.forEach((d) => {
        const option = new Option(
          d.name,
          d.id,
          false,
          dutyIds.includes(String(d.id))
        );
        minor_functions.append(option);
      });

      minor_functions.trigger("change");

      setValue("duty_id", dutyIds);
    }, 200);
  }, [duties, clientContact, data]);

  const onSubmit = (data) => {
    try {
      setGlobalLoading(true);
      axios
        .post(
          `${REACT_APP_API_BASE_URL}/roles/add_new`,
          { formdata: data },
          { headers: { Authorization: `Bearer ${token}` }, }
        )
        .then((res) => {
          console.log(res);
          if (res.status === 200) {
            toastr.success(res.data.message);
            navigate("/role/view/" + res.data.role_id);
          } else {
            console.log(res.data.error);
            toastr.error(res.data.message);
            navigate("/role/view/" + res.data.role_id);
          }
        });
    } catch (error) {
      console.log(error);
      setGlobalLoading(false);
    } finally {
      setGlobalLoading(false);
    }
  };
  useEffect(() => {
  const $selects = $(".role-searchable-select");

  $selects.each(function () {
    const $select = $(this);

    if ($select.hasClass("select2-hidden-accessible")) {
      $select.select2("destroy");
    }

    $select.select2({
      width: "100%",
      placeholder: "Select",
      allowClear: true,
    });
  });

  // COUNTRY
  const $country = $("[name='country_id']");

  $country.off("select2:select.roleForm");
  $country.on("select2:select.roleForm", function (e) {
    const value = e.params.data.id;

    setValue("country_id", value, {
      shouldValidate: true,
      shouldDirty: true,
    });

    handleCountryChange({
      target: {
        value,
      },
    });
  });

  // MAJOR FUNCTION
  const $majorFunction = $("[name='dutymaster_id']");

  $majorFunction.off("select2:select.roleForm");
  $majorFunction.on("select2:select.roleForm", function (e) {
    const value = e.params.data.id;

    setValue("dutymaster_id", value, {
      shouldValidate: true,
      shouldDirty: true,
    });

    handleDutyMasterChange({
      target: {
        value,
      },
    });
  });

  return () => {
    $country.off(".roleForm");
    $majorFunction.off(".roleForm");

    $selects.each(function () {
      const $select = $(this);

      if ($select.hasClass("select2-hidden-accessible")) {
        $select.select2("destroy");
      }
    });
  };
}, [data?.country, data?.dutymaster]);
  return (
    <>
      <div className="content">
        <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
          <div className="my-auto mb-2">
            <h2 className="mb-1">
               {isConvert ? "Review Before Converting to" : id ? "Update" : "Add"} Role
              <span style={{ marginLeft: "20px" }}>
                <button type="button" className="btn btn-primary my-1 me-2">
                  Reference Id
                  <span className="badge ms-2 bg-secondary">
                    {RoleData?.role_data?.[0]?.reference ??
                      data?.next_reference?.[0]?.next_reference}
                  </span>
                </button>
              </span>
            </h2>
          </div>
          <a href="javascript:void(0)" onClick={handleBack}>
            <i className="ti ti-arrow-left me-2"></i>Back to Roles
          </a>
        </div>
        {showAddContactModal && (
          <AddContact
            show={showAddContactModal}
            onClose={() => {
                setShowAddContactModal(false);
              }}
            company_id={selectedClientId}
            token={token}
            onSuccess={async () => {
                setShowAddContactModal(false);
                getClientContact(selectedClientId);
              }}
            />
          )}
        <div className="card">
          <div className="card-body">
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="row">
                <div className="col-xxl-12 col-xl-12 col-md-12">
                  <div className="row mb-3 me-3">
                    <input
                      type="hidden"
                      {...register("reference")}
                      value={data?.next_reference?.[0]?.next_reference}
                    />
                    <div className="col-xxl-6 col-xl-6 col-md-12">
                      <label className="form-label">
                        Role Type <span className="text-danger">*</span>
                      </label>
                      <select
                        className={`form-select ${
                          errors.roletype_id ? "is-invalid" : ""
                        }`}
                        {...register("roletype_id", {
                          required: true,
                          onChange: (e) => handleRoleTypeChange(e),
                        })}
                      >
                        <option>Select Role Type</option>
                        {data?.roletype?.map((item) => (
                          <option key={item.id} value={item.id}>
                            {item.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-xxl-6 col-xl-6 col-md-12">
                      <label className="form-label">
                        Client{" "}
                        <span className="text-danger">
                          * {errors.company_id ? "required" : ""}
                        </span>
                      </label>
                      <select
                        className={`form-select`}
                        {...register("company_id", { required: true })}
                        defaultValue=""
                      >
                        <option value=""></option>
                        {data?.companies?.map((item) => (
                          <option key={item.id} value={item.id}>
                            {item.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  {roleType === 3 && (
                    <div className="row mb-3 me-3">
                      <div className="col-xxl-6 col-xl-6 col-md-12">
                        <label className="form-label">Report Type</label>
                        <select
                          className={`form-select`}
                          {...register("reporttype_id", {
                            required: true,
                            onChange: (e) => reportTypeChange(e),
                          })}
                        >
                          {data?.reporttype?.map((item) => (
                            <option key={item.id} value={item.id}>
                              {item.name}
                            </option>
                          ))}
                        </select>
                      </div>
                      {reportType === 5 && (
                        <div className="col-xxl-6 col-xl-6 col-md-12">
                          <label className="form-label">
                            Report Name <span className="text-danger">*</span>{" "}
                            <span className="fs-9">Add New Report Type</span>
                          </label>
                          <input
                            type="text"
                            className={`form-control ${
                              errors.otherreport ? "is-invalid" : ""
                            }`}
                            {...register("otherreport", { required: true })}
                          />
                        </div>
                      )}
                    </div>
                  )}
                  <div className="row mb-3 me-3">
                    <div className="col-xxl-6 col-xl-6 col-md-12">
                      <label className="form-label">
                        Role Manager{" "}
                        <span className="text-danger">
                          * {errors.user_id ? "required" : ""}
                        </span>
                      </label>
                      <select
                        className={`form-select`}
                        {...register("user_id", { required: true })}
                      >
                        <option value=""></option>
                        {data?.user?.map((item) => (
                          <option key={item.id} value={item.id}>
                            {item.firstname} {item.lastname}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-xxl-6 col-xl-6 col-md-12">
                      <div className="d-flex align-items-center justify-content-between mb-1">
                        <label className="form-label mb-0">
                          Client Contact <span className="text-danger"></span>
                        </label>
                        {selectedClientId && (
                          <button type="button" className="btn btn-sm btn-outline-primary" onClick={() => setShowAddContactModal(true)}>
                            <i className="ti ti-plus me-1"></i>
                            Add New Contact
                          </button>
                        )}
                      </div>

                      <select
                        className={`form-select ${
                          errors.client_contact_id ? "is-invalid" : ""
                        }`}
                        {...register("client_id", { required: false })}
                        disabled={!(clientContact?.client_contacts?.length > 0)}
                      >
                        <option value="">Select Client Contact</option>
                        {clientContact?.client_contacts?.map((item) => (
                          <option key={item.id} value={item.id}>
                            {`${item.firstname} ${item.lastname} (${item.designation})`}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="row mb-3 me-3">
                    <div className="col-xxl-6 col-xl-6 col-md-12">
                      <label className="form-label">
                        {roleType === 2
                          ? "Role Designation"
                          : roleType === 3
                          ? "Report Title"
                          : "Title"}
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control ${
                          errors.name ? "is-invalid" : ""
                        }`}
                        placeholder={
                          roleType === 2
                            ? "Role Designation"
                            : roleType === 3
                            ? "Report Title"
                            : "Title"
                        }
                        {...register("name", { required: true })}
                        autoComplete="off"
                      />
                    </div>
                    <div className="col-xxl-6 col-xl-6 col-md-12">
                      <label className="form-label">
                        Bill Type <span className="text-danger">*</span>
                      </label>
                      <select
                        className={`form-select ${
                          errors.billtype_id ? "is-invalid" : ""
                        }`}
                        {...register("billtype_id", { required: true })}
                      >
                        <option value={""}>Select Bill Type</option>
                        {data?.billtype?.map((item) => (
                          <option key={item.id} value={item.id}>
                            {item.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  {roleType === 2 && (
                    <div className="row mb-3 me-3">
                      <div className="col-xxl-6 col-xl-6 col-md-12">
                        <label className="form-label">
                          Role Level
                          <span className="text-danger">*</span>
                        </label>
                        <select
                          className={`form-select ${
                            errors.rolelevel_id ? "is-invalid" : ""
                          }`}
                          {...register("rolelevel_id", { required: true })}
                        >
                          <option value={""}>Select Role Level</option>
                          {data?.rolelevel?.map((item, index) => (
                            <option key={index} value={item.id}>
                              {item.name}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="col-xxl-6 col-xl-6 col-md-12">
                        <label className="form-label">
                          Band / Title{" "}
                          <span className="fs-9">
                            [ e.g. BandE / BandF / AVP / VP / CIM ]
                          </span>
                        </label>
                        <input
                          type="text"
                          className={`form-control `}
                          placeholder="Band / Title"
                          {...register("band")}
                          autoComplete="off"
                        />
                      </div>
                    </div>
                  )}
                  <div className="row mb-3 me-3">
                    <div className="col-xxl-6 col-xl-6 col-md-12">
                      <label className="form-label">
                        Country <span className="text-danger">*</span>
                      </label>
                      <select
                        className={`form-select role-searchable-select ${
                          errors.country_id ? "is-invalid" : ""
                        }`}
                        {...register("country_id", {
                          required: true,
                          onChange: (e) => handleCountryChange(e),
                        })}
                      >
                        <option value={""}>Select Country</option>
                        {data?.country?.map((item) => (
                          <option key={item.id} value={item.id}>
                            {item.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-xxl-6 col-xl-6 col-md-12">
                      <label className="form-label">
                        Region <span className="text-danger">*</span>
                      </label>
                      <input
                        type="hidden"
                        name="region_id"
                        {...register("region_id")}
                      />
                      <input
                        type="text"
                        className={`form-control`}
                        readOnly={true}
                        placeholder="Region"
                        value={region ?? ""}
                      />
                    </div>
                  </div>
                  {roleType === 1 && (
                    <div className="row mb-3 me-3">
                      <div className="col-xxl-12 col-xl-12 col-md-12">
                        <label className="form-label">
                          Compensation Range{" "}
                          {errors.compensation_range_from && (
                            <span className="text-danger">
                              {errors.compensation_range_from.message}
                            </span>
                          )}
                          {errors.compensation_range_to && (
                            <span className="text-danger">
                              {errors.compensation_range_to.message}
                            </span>
                          )}
                        </label>
                        <div className="input-group">
                          <input
                            type="text"
                            {...register("compensation_range_from", {
                              pattern: {
                                value: /^[0-9]+$/,
                                message:
                                  "Only numbers are allowed without comma",
                              },
                            })}
                            className="form-control"
                          />
                          <span
                            className="input-group-text me-1 ms-1"
                            style={{ minHeight: "34px" }}
                          >
                            to
                          </span>
                          <input
                            type="text"
                            {...register("compensation_range_to", {
                              pattern: {
                                value: /^[0-9]+$/,
                                message:
                                  "Only numbers are allowed without comma",
                              },
                            })}
                            className="form-control"
                          />
                        </div>
                      </div>
                    </div>
                  )}
                  {roleType === 2 && (
                    <div className="row mb-3 me-3">
                      <div className="col-xxl-6 col-xl-6 col-md-12">
                        <label className="form-label">City</label>
                        <input
                          type="text"
                          className={`form-control`}
                          placeholder="City"
                          {...register("location")}
                        />
                      </div>
                      <div className="col-xxl-6 col-xl-6 col-md-12">
                        <label className="form-label">
                          Expected Compensation{" "}
                          <span className="text-danger">
                            *{" "}
                            {errors.expected_compensation &&
                              errors.expected_compensation.message}{" "}
                          </span>
                        </label>
                        <div className="input-group">
                          <input
                            type="text"
                            className={`form-control ${
                              errors.expected_compensation ? "is-invalid" : ""
                            }`}
                            placeholder="Expected Compensation"
                            {...register("expected_compensation", {
                              required: true,
                              pattern: {
                                value: /^[0-9]+$/, // only digits allowed
                                message: "Only numbers allowed without commas",
                              },
                            })}
                            autoComplete="off"
                          />
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="row mb-3 me-3">
                    <div className="col-xxl-6 col-xl-6 col-md-12">
                      <label className="form-label">
                        Expected Approx Fee{" "}
                        <span className="text-danger">
                          *{" "}
                          {errors.expected_approx_fee &&
                            errors.expected_approx_fee.message}
                        </span>
                      </label>
                      <div className="input-group">
                        <span>
                          <select
                            style={{ maxHeight: "34px", maxWidth: "100px" }}
                            className={`form-select`}
                            {...register("currency_id_alt", {
                              required: true,
                              onChange: (e) => handleCurrencyChange(e),
                            })}
                          >
                            {data?.currency?.map((item) => (
                              <option key={item.id} value={item.id}>
                                {`${item.symbol} - ${item.name}`}
                              </option>
                            ))}
                          </select>
                        </span>
                        <input
                          type="text"
                          className={`form-control ${
                            errors.expected_approx_fee ? "is-invalid" : ""
                          }`}
                          placeholder="Approx Fee"
                          {...register("expected_approx_fee", {
                            required: true,
                            pattern: {
                              value: /^[0-9]+$/, // only digits allowed
                              message: "Only numbers allowed without commas",
                            },
                          })}
                          autoComplete="off"
                        />
                      </div>
                    </div>
                    <div className="col-xxl-6 col-xl-6 col-md-12">
                      <label className="form-label">
                        Fees Conversion Rate{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control ${
                          errors.conversion_rate ? "is-invalid" : ""
                        }`}
                        placeholder="Fees Conversion Rate"
                        {...register("conversion_rate", {
                          required: true,
                        })}
                        autoComplete="off"
                        value={conversionRate ?? 1}
                      />
                    </div>
                  </div>
                  <div className="row mb-3 me-3">
                    <div className="col-xxl-6 col-xl-6 col-md-12">
                      <label className="form-label">
                        Major Function <span className="text-danger">*</span>
                      </label>
                      <select
                        className={`form-select role-searchable-select ${
                          errors.dutymaster_id ? "is-invalid" : ""
                        }`}
                        {...register("dutymaster_id", {
                          required: true,
                          onChange: (e) => handleDutyMasterChange(e),
                        })}
                      >
                        <option value={""}>Select Major Function</option>
                        {data?.dutymaster?.map((item) => (
                          <option key={item.id} value={item.id}>
                            {item.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-xxl-6 col-xl-6 col-md-12">
                      <label className="form-label">
                        Functions{" "}
                        <span className="text-danger">
                          * {errors.duty_id ? "required" : ""}
                        </span>
                      </label>
                      <select
                        className={`form-select`}
                        {...register("duty_id", {
                          required: true,
                        })}
                        disabled={duties.length <= 0 ? true : false}
                      >
                        {duties.length > 0 &&
                          duties?.map((item, index) => (
                            <option key={index} value={item.id}>
                              {item.name}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>
                  {roleType == 2 && (
                    <div className="row mb-3 me-3">
                      <div className="col-xxl-4 col-xl-4 col-md-12">
                        <label className="form-label">Role Activate</label>
                        <div className="form-check form-check-lg form-switch">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            role="switch"
                            {...register("active")}
                          />
                        </div>
                      </div>
                      <div className="col-xxl-4 col-xl-4 col-md-12">
                        <label className="form-label">Dossier</label>
                        <div className="form-check form-check-lg form-switch">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            role="switch"
                            {...register("dossier")}
                          />
                        </div>
                      </div>
                      <div className="col-xxl-4 col-xl-4 col-md-12">
                        <label className="form-label">No. of Position</label>
                        <input
                            type="number"
                            className={`form-control ${
                              errors.position_number ? "is-invalid" : ""
                            }`}
                            placeholder="No. of Position"
                            {...register("position_number", {
                              required: true,
                            })}
                            defaultValue={1}
                            min={1}
                            max={10}
                            autoComplete="off"
                          />
                      </div>
                    </div>
                  )}
                  <div className="row mb-3 me-3">
                    <div className="col-xxl-6 col-xl-6 col-md-12">
                      <label className="form-label">
                        {" "}
                        Activation Date <span className="text-danger">
                          *
                        </span>{" "}
                      </label>
                      <input
                        type="date"
                        className={`datetimepicker form-control ${
                          errors.start ? "is-invalid" : ""
                        }`}
                        placeholder="DD/MM/YYYY"
                        {...register("start", {
                          required: true,
                        })}
                      />
                    </div>
                    <div className="col-xxl-6 col-xl-6 col-md-12">
                      <label className="form-label">
                        Status <span className="text-danger">*</span>
                      </label>
                      <select
                        className={`form-select ${errors.rolestatus_id ? "is-invalid" : ""}`}
                        {...register("rolestatus_id", { required: true,})}
                      >
                        {data?.status?.map((item) => (
                          <option key={item.id} value={item.id}>
                            {item.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="row mb-3 me-3">
                    <div className="col-xxl-12 col-xl-12 col-md-12">
                      <label>Description </label>
                      <textarea
                        className="form-control"
                        {...register("description")}
                        placeholder="Write Role Description Here..."
                      ></textarea>
                    </div>
                  </div>
                  {roleType == 2 && (
                    <div className="row mb-3 me-3">
                      <div className="col-xxl-6 col-xl-6 col-md-12">
                        <label>Invoice Address</label>
                        <textarea
                          className="form-control"
                          {...register("invoiceAddress")}
                          placeholder="Write Invoice Address Here..."
                        ></textarea>
                      </div>
                      <div className="col-xxl-6 col-xl-6 col-md-12">
                        <label>Notes</label>
                        <textarea
                          className="form-control"
                          {...register("note")}
                          placeholder="Write Notes Here..."
                        ></textarea>
                      </div>
                    </div>
                  )}
                  <div className="row mb-3 me-3">
                    <div className="col-xxl-12 col-xl-12 col-md-12">
                      <label>
                        Role Key Attributes{" "}
                        <span className="text-danger">*</span>
                        <a
                          href="javascript:void(0);"
                          className="align-items-center fs-12 ms-2"
                          onClick={(e) => handleAddMore(e)}
                        >
                          <i className="ti ti-circle-plus me-1"></i>Add More
                        </a>
                      </label>
                      {extraInputs.map((index) => (
                        <div
                          key={index}
                          className="d-flex align-items-center mb-1"
                        >
                          <input
                            type="text"
                            className={`form-control mb-1 role_criteria ${
                              errors.p_scnt?.[index] ? "is-invalid" : ""
                            }`}
                            {...register(`p_scnt.${index}`, { required: true })}
                            placeholder="Key Criteria"
                            autoComplete="off"
                          />
                          {index > 2 && (
                            <button
                              type="button"
                              className="btn btn-danger btn-sm"
                              onClick={() => {
                                setExtraInputs((prev) => {
                                  // Remove the chosen one and reindex from 0...n
                                  const newArr = prev.filter(
                                    (_, i) => i !== index
                                  );
                                  return newArr.map((_, i) => i);
                                });

                                unregister(`p_scnt.${index}`);
                              }}
                            >
                              <i className="ti ti-trash"></i>
                            </button>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="row mb-3 me-3">
                    <div className="offset-xxl-9 offset-xl-9 col-xxl-3 col-xl-3 col-md-12">
                      <button type="submit" className="btn btn-primary me-2 float-end">
                       {isConvert ? "Convert to" : id ? "Update" : "Add"} Role
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddNewRole;
